// material-ui

import calculatoricon from '../../../assets/images/bx-calculator.svg';
/**
 * if you want to use image instead of <svg> uncomment following.
 *
 * import logoDark from 'assets/images/logo-dark.svg';
 * import logo from 'assets/images/logo.svg';
 *
 */

// ==============================|| LOGO SVG ||============================== //

const CalculatorIcon = () => {
    

    return (
        /**
         * if you want to use image instead of svg uncomment following, and comment out <svg> element.
         *
         * <img src={logo} alt="Berry" width="100" />
         *
         */
         <img src={calculatoricon} alt="Calculator" width="22"  />
    );
};

export default CalculatorIcon;


